/* src/app/modules/stats/components/machines-stats-container/machines-stats-bar-chart-tooltip/machines-stats-bar-chart-tooltip.component.scss */
#main-container {
  background-color: rgba(0, 0, 0, 0.8);
}
table.machine-data {
  width: 100%;
  color: white;
}
table.machine-data > tbody > tr > td {
  border: 1px solid #E8E8E8;
  padding-left: 10px;
  padding-right: 10px;
}
table.machine-data > tbody > tr > td.value {
  font-size: 1.5em;
}
/*# sourceMappingURL=machines-stats-bar-chart-tooltip.component.css.map */
